<div class="loader" *ngIf="showLoader">
    <mat-spinner [diameter]="40" color="primary"></mat-spinner>&nbsp;<span style="font-weight: 600; font-size: 1.2rem;" >Uploading Document Please Wait .....</span>
</div>


<router-outlet></router-outlet>
